import { Box, Checkbox, ListItem, Typography } from "@mui/material"
import { grey } from "@mui/material/colors"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { BlockClicks } from "lib/@components/block-clicks"
import { If } from "lib/@components/switch"
import { SCHEDULE } from "library/constants"
import { findInChildren, parentTreeItem } from "library/tree"
import Iconify from "minimals-template/components/Iconify"
import { isScheduleSelectable } from "../lib/is-schedule-selectable"

export function ScheduleGroupItem({ item }) {
    const { selected, onOpen, onSelectAll, lockDataById } = useBoundContext()
    const { label } = item
    const isRootFolder = item?.[parentTreeItem].id === "schedules"

    const childSchedules = isRootFolder ? [] : findInChildren(item, (c) => c.$.type === SCHEDULE)
    const selectableChildren = childSchedules.filter((schedule) => isScheduleSelectable(schedule, lockDataById))
    const selectedChildren = selectableChildren.filter(({ _id }) => selected[_id])

    const allSelected = selectableChildren.length > 0 && selectableChildren.length === selectedChildren.length
    const someSelected = selectedChildren.length > 0 && !allSelected

    return (
        <ListItem
            sx={{
                cursor: "pointer",
                borderBottom: `1px solid ${grey[200]}`,
                minHeight: "50px",
                color: isRootFolder || selectableChildren.length ? "text.primary" : "text.secondary",
            }}
            data-cy="schedule-group"
            onClick={handleOpen}
        >
            <Box display={"flex"} alignItems={"center"} gap={1} width={"100%"}>
                <If truthy={!isRootFolder}>
                    <BlockClicks>
                        <Checkbox
                            data-cy="schedule-group-checkbox"
                            checked={!!allSelected}
                            indeterminate={!allSelected && someSelected}
                            onClick={handleSelect}
                            disabled={!selectableChildren.length}
                        />
                    </BlockClicks>
                </If>
                <Iconify
                    icon={isRootFolder ? "material-symbols:folder" : "ic:twotone-folder"}
                    sx={{
                        color: !selectableChildren.length && !isRootFolder ? "text.secondary" : "primary.main",
                        height: "25px",
                        width: "25px",
                    }}
                />
                <Typography>{label}</Typography>
            </Box>
        </ListItem>
    )

    function handleSelect() {
        const deselect = Boolean(allSelected || someSelected)
        onSelectAll(childSchedules, deselect)
    }

    function handleOpen() {
        onOpen(item)
    }
}
